import React from 'react';
import { Col, Row, Container } from '../../landing.common';
import { Product } from './components/product';
import { Organization } from './components/organization';
import styles from './styles.module.scss';
import { useAutoSendProductParams } from '../../../store/reducers/autoSendProduct';

export const ProductHeader: React.FC = () => {
    const { selectionProductId } = useAutoSendProductParams();

    if (!selectionProductId) {
        return null;
    }

    return (
        <Container>
            <Row className={styles['header-container']}>
                <Col md-8 className={styles['header-container__product-col']}>
                    <Product />
                </Col>
                <Col md-4 className={styles['header-container__organization-col']}>
                    <Organization />
                </Col>
            </Row>
        </Container>
    );
};
